const letter_type_list = [
    {
        id: 0,
        name: "所有",
        tag: "primary",
    },
    {
        id: 1,
        name: "评论",
        tag: "primary",
    },
    {
        id: 2,
        name: "回复",
        tag: "success",
    },
    {
        id: 3,
        name: "点赞",
        tag: "danger",
    },
    {
        id: 4,
        name: "私信",
        tag: "warning",
    },
    {
        id: 5,
        name: "系统",
        tag: "info",
    },
]

//AFTER SALE
const afterSalesArray = {
    // statusList: {
    // '0': {
    //     name: '所有',
    //     tag: ''
    // },
    // '-1': {
    //     name: '取消',
    //     tag: ''
    // },
    // '9001000': {
    //     name: '处理完毕',
    //     tag: ''
    // },
    // '2001000': {
    //     name: '业务员拒绝受理',
    //     tag: 'danger'
    // },
    // '2001001': {
    //     //审核按钮
    //     name: '等待业务员受理',
    //     tag: 'warning'
    // },
    // '2001002': {
    //     name: '业务员受理通过',
    //     tag: ''
    // },
    // '2002000': {
    //     name: '售后中心拒绝受理',
    //     tag: 'danger'
    // },

    // '2002001': {
    //     name: '等待售后中心受理',
    //     tag: 'warning'
    // },
    // '2002002': {
    //     name: '售后中心受理中',
    //     tag: 'success'
    // },
    // '2002003': {
    //     name: '售后中心受理完成',
    //     tag: ''
    // },
    // '2003000': {
    //     name: '服务点拒绝受理',
    //     tag: 'danger'
    // },
    // '2003001': {
    //     name: '等待服务点受理',
    //     tag: 'warning'
    // },
    // '2003002': {
    //     name: '服务点受理中',
    //     tag: 'success'
    // },
    // '2003003': {
    //     //备注
    //     name: '服务点受理完成',
    //     tag: ''
    // },
    // '3001001': {
    //     name: '新建工单',
    //     tag: 'warning'
    // },
    // '3001002': {
    //     name: '直接新建工单',
    //     tag: 'warning'
    // },
    // '3002001': {
    //     name: '等待客户答复',
    //     tag: 'success'
    // },
    // '3003001': {
    //     name: '等待CSR答复',
    //     tag: 'success'
    // },
    // '3004001': {
    //     name: '超时关闭工单',
    //     tag: ''
    // },
    // '3004002': {
    //     name: 'CSR回复，并关闭工单',
    //     tag: ''
    // },
    // '3004003': {
    //     name: '客户主动关闭工单',
    //     tag: 'danger'
    // },
    // '3009001': {
    //     name: '客户自助解決记录',
    //     tag: ''
    // },
    // },
    statusList: [
        {
            value: 0,
            name: '所有',
            tag: ''
        },
        {
            value: 3001001,
            name: '新建工单',
            tag: ''
        },
        {
            value: 3001002,
            name: '直接新建工单',
            tag: 'warning'
        },
        {
            value: 3002001,
            name: '等待客户答复',
            tag: 'info'
        },
        {
            value: 3003001,
            name: '等待CSR答复',
            tag: 'info'
        },
        {
            value: 3004001,
            name: '超时关闭工单',
            tag: 'danger'
        },
        // {
        //     value: 3004002,
        //     name: 'CSR回复，并关闭工单',
        //     tag: 'success'
        // },
        {
            value: 3004003,
            name: '客户主动关闭工单',
            tag: 'success'
        },
        {
            value: 3004004,
            name: 'CRS拒绝处理关闭工单',
            tag: 'danger'
        },
        {
            value: 3004005,
            name: '客服完成并完成工单',
            tag: 'success'
        },
    ],
    // channelList: {
    //     '0': {
    //         name: '所有',
    //         tag: ''
    //     },
    //     '1000': {
    //         name: '其它',
    //         tag: ''
    //     },
    //     '1001': {
    //         name: 'SMOK 官方平台',
    //         tag: ''
    //     },
    //     // '0':"所有",
    //     // '1000': '其它',
    //     // '1001': 'SMOK 官方平台',
    //     // '1002': '经销商',
    //     // '1003': 'SMOK 天猫旗舰店'
    // },
    channelList: [
        {
            value: 0,
            name: '所有',
        },
        {
            value: 1000,
            name: '其它',
        },
        {
            value: 1001,
            name: 'SMOK 官方平台',
        },
    ],

    typeList: {
        '0': "所有",
        '1001': '零售',
        '1002': '分销'
    },
    // problemList: {
    //     // '客责': ['无'],
    //     // '漏油': ['漏油'],
    //     // '包装问题': ['包装不良'],
    //     // '外观异常': ['外观不良（玻璃管、密封圈除外）', '玻璃管破裂', '密封圈问题', '掉漆', '色差'],
    //     // '结构缺陷': ['下盖盖不紧', '510接触问题不良', '上盖脱落', '弹针下陷', '外壳脱落', '螺牙问题', '电池盖磁铁脱落', '上盖拧不紧', '气流阀卡死', '滴嘴装不上', '电池箱变形', '烟弹松动'],
    //     // '组装缺陷': ['制程不良'],
    //     // '产品型号错误': ['产品型号错误'],
    //     // '部件缺失': ['短装'],
    //     // '功能异常': ['无法开机', '不能抽烟', '充电不良', '屏幕不良', '按键不良', '电量检测不准', '检测阻值不准', '升级不良', '自动抽烟', '输出短路', '电池短路',
    //     //   '自动关机', '烧焦味', '耗电太快', '显示自动充电', '不升压', 'LED灯坏', '触屏功能失效', '震动功能失效', '功能缺失'],
    //     // '产品安全责任事故': ['违反法律法规（起火爆炸除外）', '起火爆炸'],
    //     // '主观不满意': ['无'],
    //     // '咨询': ['产品咨询', '订单咨询', '订单变更', '订单取消', '销售业务咨询（订单）', '营销业务咨询（推广）', '产品宣传与产品实物不符'],
    //     // '防伪码异常': ['防伪码缺失', '防伪码验证报错', '防伪码重复']
    //     'Mod 功能问题': ['屏幕问题', '不能开机', '不能抽烟', '按键不良', '自动抽烟', '充电不良', '自动关机', '耗电异常', '产品过热', 'LED灯坏', '阻值检测不准', '正极接触烧坏'],
    //     'Mod 结构问题': ['弹针下陷', '烟弹松动', '510螺牙异常', '电池盖盖不紧', '产品外壳开裂'],
    //     '烟弹/雾化器': ['漏油', '核芯烧焦', '密封圈问题', '烟弹开裂', '滴嘴问题', '气流阀卡死', '核心装配异常'],
    //     '其他': ['订单咨询', '起火爆炸', '包装问题', '外观问题', '产品型号问题', '假货']
    // },
    problemList: [
        {
            value: 'Mod 功能问题 Mod function problem',
            label: 'Mod 功能问题 Mod function problem',
            children: [
                {
                    value: '屏幕问题 Display malfunction',
                    label: '屏幕问题 Display malfunction',
                },
                {
                    value: '不能开机 Will not turn on',
                    label: '不能开机 Will not turn on',
                },
                {
                    value: '不能抽烟 Will not fire',
                    label: '不能抽烟 Will not fire',
                },
                {
                    value: '按键不良 Button malfunction',
                    label: '按键不良 Button malfunction',
                },
                {
                    value: '自动抽烟 Auto firing',
                    label: '自动抽烟 Auto firing',
                },
                {
                    value: "充电不良 Can't be charged",
                    label: "充电不良 Can't be charged",
                },
                {
                    value: '自动关机 Auto shutdown',
                    label: '自动关机 Auto shutdown',
                },
                {
                    value: '耗电异常 Abnormal power consumption',
                    label: '耗电异常 Abnormal power consumption',
                },
                {
                    value: '产品过热 Overheating',
                    label: '产品过热 Overheating',
                },
                {
                    value: 'LED灯坏 Bad LED light',
                    label: 'LED灯坏 Bad LED light',
                },
                {
                    value: '阻值检测不准 Inaccurate resistance detection',
                    label: '阻值检测不准 Inaccurate resistance detection',
                },
                {
                    value: '正极接触烧坏 Positive contact burnout',
                    label: '正极接触烧坏 Positive contact burnout',
                },

            ],
        },
        {
            value: 'Mod 结构问题 Mod structure problem',
            label: 'Mod 结构问题 Mod structure problem',
            children: [
                {
                    value: '弹针下陷 Pin stuck',
                    label: '弹针下陷 Pin stuck',
                },
                {
                    value: '烟弹松动 Pod detachment',
                    label: '烟弹松动 Pod detachment',
                },
                {
                    value: '510螺牙异常 510 connection problem',
                    label: '510螺牙异常 510 connection problem',
                },
                {
                    value: '电池盖盖不紧 Battery cover is not tight',
                    label: '电池盖盖不紧 Battery cover is not tight',
                },
                {
                    value: '产品外壳开裂 Cracked product shell',
                    label: '产品外壳开裂 Cracked product shell',
                },
                {
                    value: '底座脱落 The base comes off',
                    label: '底座脱落 The base comes off',
                },
            ],
        },
        {
            value: '烟弹/雾化器 Pod/Tank',
            label: '烟弹/雾化器 Pod/Tank',
            children: [
                {
                    value: '漏油 Leakage',
                    label: '漏油 Leakage',
                },
                {
                    value: '核芯烧焦 Burnt coil',
                    label: '核芯烧焦 Burnt coil',
                },
                {
                    value: '密封圈问题 Sealing ring problems',
                    label: '密封圈问题 Sealing ring problems',
                },
                {
                    value: '烟弹开裂 Cracked pod',
                    label: '烟弹开裂 Cracked pod',
                },
                {
                    value: '滴嘴问题 Drip tip promblem',
                    label: '滴嘴问题 Drip tip promblem',
                },
                {
                    value: '气流阀卡死 Air inlet stuck',
                    label: '气流阀卡死 Air inlet stuck',
                },
                {
                    value: '核心装配异常 Abnormal coil assembly',
                    label: '核心装配异常 Abnormal coil assembly',
                },
            ],
        },
        {
            value: '功能异常 Abnormal function',
            label: '功能异常 Abnormal function',
            children: [
                {
                    value: '无法开机 Will not turn on',
                    label: '无法开机 Will not turn on',
                },
                {
                    value: '不能抽烟 Will not fire',
                    label: '不能抽烟 Will not fire',
                },
                {
                    value: "充电不良 Can't be charged",
                    label: "充电不良 Can't be charged",
                },
                {
                    value: '屏幕不良 Display malfunction',
                    label: '屏幕不良 Display malfunction',
                },
                {
                    value: '按键不良 Button malfunction',
                    label: '按键不良 Button malfunction',
                },
                {
                    value: '电量检测不准 Inaccurate power detection',
                    label: '电量检测不准 Inaccurate power detection',
                },
                {
                    value: '检测阻值不准 Inaccurate detection of resistance value',
                    label: '检测阻值不准 Inaccurate detection of resistance value',
                },
                {
                    value: '升级不良 Upgrading failure',
                    label: '升级不良 Upgrading failure',
                },
                {
                    value: '自动抽烟 Auto firing',
                    label: '自动抽烟 Auto firing',
                },
                {
                    value: '输出短路 Output short circuit',
                    label: '输出短路 Output short circuit',
                },
                {
                    value: '电池短路 Battery short circuit',
                    label: '电池短路 Battery short circuit',
                },
            ],
        },
        {
            value: '漏油 Leakage',
            label: '漏油 Leakage',
            children: [
                {
                    value: '漏油 Leakage',
                    label: '漏油 Leakage',
                },
            ],
        },
        {
            value: '其他 Others',
            label: '其他 Others',
            children: [
                {
                    value: '订单咨询 Question',
                    label: '订单咨询 Question',
                },
                {
                    value: '起火爆炸 Fire and explosion',
                    label: '起火爆炸 Fire and explosion',
                },
                {
                    value: '包装问题 Packaging problem',
                    label: '包装问题 Packaging problem',
                },
                {
                    value: '外观问题 Appearance problems',
                    label: '外观问题 Appearance problems',
                },
                {
                    value: '产品型号问题 Product Model Issues',
                    label: '产品型号问题 Product Model Issues',
                },
                {
                    value: '假货 Counterfeit product',
                    label: '假货 Counterfeit product',
                },
            ],
        },

    ],
    downloadStatus: {
        '0': '全部状态',
        '212': '处理中',
        '-4': '处理完毕',
    },
    categoryStatusList: [
        {
            value: 0,
            name: '所有',
        },
        {
            value: 3002,
            name: '等待客户答复',
        },
        {
            value: 3003,
            name: '等待CSR回复',
        },
        {
            value: 3004,
            name: '关闭工单',
        },
        // '0':'所有',
        // '3001': '新建工单',
        // '3002': '等待客户答复',
        // '3003': '等待CSR答复',
        // '3004': '关闭工单',
        // '3005': '拒绝受理',
        // '3006': '处理中',
        // '3007': '处理完毕',
        // '3009': '自动记录',
    ],
    statusCategories: {
        manager: {
            '0': '全部状态',
            '200': '拒绝处理',
            '201': '等待处理',
            '202': '处理中',
            '-4': '处理完毕',
            '-1': '取消'
        }, default: {
            '0': '全部状态',
            '210': '拒绝处理',
            '211': '等待处理',
            '212': '处理中',
            '-4': '处理完毕',
            '-1': '取消'
        }, operator: {
            '0': '全部状态',
            '220': '拒绝处理',
            '221': '等待处理',
            '222': '处理中',
            '-4': '处理完毕',
            '-1': '取消'
        }, agency: {
            '0': '全部状态',
            '230': '拒绝处理',
            '231': '等待处理',
            '232': '处理中',
            '-4': '处理完毕',
            '-1': '取消'
        }
    },
    statusCategoryList: {
        manager: {
            '0': {
                '0': '全部状态'
            },
            '200': {
                '200': '全部状态',
                '2001000': '业务员拒绝受理',
                '2002000': '售后中心拒绝受理',
                '2003000': '服务点拒绝受理'
            },
            '201': {
                '201': '全部状态',
                '2001001': '等待业务员受理',
                '2002001': '等待售后中心受理',
                '2003001': '等待服务点受理'
            },
            '202': {
                '202': '全部状态',
                '2001002': '业务员受理通过',
                // '2002001': '等待售后中心受理',
                '2002002': '售后中心受理中',
                '2003001': '等待服务点受理',
                '2003002': '服务点受理中'
            },
            '-4': {
                '-4': '全部状态',
                '2002003': '售后中心受理完成',
                '2003003': '服务点受理完成',
                '9001000': '用户确认处理完毕'
            },
            '-1': {
                '-1': '全部状态'
            }
        },
        default: {
            '0': {
                '0': '全部状态'
            },
            '210': {
                '210': '全部状态',
                '2001000': '业务员拒绝受理',
                '2002000': '售后中心拒绝受理',
                '2003000': '服务点拒绝受理'
            },
            '211': {
                '211': '全部状态',
                '2001001': '等待业务员受理'

            },
            '212': {
                '212': '全部状态',
                '2001002': '业务员受理通过',
                // '2002001': '等待售后中心受理',
                '2002002': '售后中心受理中',
                '2003001': '等待服务点受理',
                '2003002': '服务点受理中'
            },
            '-4': {
                '-4': '全部状态',
                '2002003': '售后中心受理完成',
                '2003003': '服务点受理完成',
                '9001000': '用户确认处理完毕'
            },
            '-1': {
                '-1': '全部状态'
            }
        },
        operator: {
            '0': {
                '0': '全部状态'
            },
            '220': {
                '220': '全部状态',
                '2002000': '售后中心拒绝受理',
                '2003000': '服务点拒绝受理'
            },
            '221': {
                '221': '全部状态',
                '2002001': '等待售后中心受理'
            },
            '222': {
                '222': '全部状态',
                '2002002': '售后中心受理中',
                '2003001': '等待服务点受理',
                '2003002': '服务点受理中'
            },
            '-4': {
                '-4': '全部状态',
                '2002003': '售后中心受理完成',
                '2003003': '服务点受理完成',
                '9001000': '用户确认处理完毕'
            },
            '-1': {
                '-1': '全部状态'
            }
        },
        agency: {
            '0': {
                '0': '全部状态'
            },
            '230': {
                '230': '全部状态',
                '2003000': '服务点拒绝受理'
            },
            '231': {
                '231': '全部状态',
                '2003001': '等待服务点受理'
            },
            '232': {
                '232': '全部状态',
                '2003002': '服务点受理中'
            },
            '-4': {
                '-4': '全部状态',
                // '2002003': '售后中心受理完成',
                '2003003': '服务点受理完成',
                '9001000': '用户确认处理完毕'
            },
            '-1': {
                '-1': '全部状态'
            },
        }
    }
};

export {afterSalesArray, letter_type_list}

const CacheKey = {
    language: {
        list: 'languageList',
        locale: 'languageLocale'
    },
    banner: {
        aspectRatioList: 'bannerAspectRatioList',
        classList: 'bannerClassList'
    }
}

export function GetCacheKey(moduleName) {
    if (typeof moduleName !== 'string') {
        throw new TypeError('模块名必须为字符串类型');
    }

    const key = CacheKey[moduleName];
    if (!key) {
        throw new ReferenceError(`未定义的缓存模块: ${moduleName}`);
    }

    return key;
}
